import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'

import { LIBRARY_URL, OLD_LIBRARY_URL, pollPreviewUrl } from '../../urls'

import { pollBuilderSaveButtonClick } from '../../sagas/savePoll'
import { pollBuilderDeleteButtonClick } from '../../sagas/deletePoll'

import Condition from '../Condition'
import CopyPollButton from '../PollCopy/CopyButton'
import CopyPollUrl from '../polls/CopyPollUrl'
import CopyEmbedScript from '../polls/CopyEmbedScript'
import ColorButton from '../Controls/ColorButton'
import { selectCurrentUser } from '../../stores/currentUser'
import { hasDmpPermissions, isToolUser } from '../../stores/usersStore'

const PERMISSIONS_DENIED_TOOLTIP =
  'You don’t have permissions to edit this poll'

export function Controls({
  poll,
  savePoll,
  deletePoll,
  isFormValid,
  hasDmpPermissions,
  toolEnabled,
}) {
  const isNew = poll.id == null
  const isEditable =
    !poll.dmpIntegration || (hasDmpPermissions && poll.dmpIntegration)

  const tooltip = isEditable ? '' : PERMISSIONS_DENIED_TOOLTIP
  const isSaveDisabled = !isEditable || !isFormValid
  const onSaveClick = async e => {
    e.preventDefault()
    if (!isEditable) return
    savePoll()
  }

  const onDeleteClick = e => {
    e.preventDefault()
    if (!isEditable) return
    const confirm = window.confirm(
      'Are you sure that you want to delete this poll?'
    )
    if (confirm) {
      deletePoll()
    }
  }

  const navigateToLibrary = () => {
    window.location.href = LIBRARY_URL
  }

  return (
    <div className="tr">
      <Condition shouldRender={isNew}>
        <Condition shouldRender={toolEnabled}>
          <a className="link" onClick={navigateToLibrary}>
            <ColorButton colorClass="gray" borderClass="b--gray">
              Cancel
            </ColorButton>
          </a>
        </Condition>
        <Condition shouldRender={!toolEnabled}>
          <Link className="link" to={OLD_LIBRARY_URL}>
            <ColorButton colorClass="gray" borderClass="b--gray">
              Cancel
            </ColorButton>
          </Link>
        </Condition>
        <ColorButton
          onClick={onSaveClick}
          title={tooltip}
          disabled={isSaveDisabled}
          className="button-poll-save ml2"
          colorClass={`${isSaveDisabled ? 'gray' : 'op-brand'}`}
          borderClass={`${isSaveDisabled ? 'b--gray' : 'b--op-brand'}`}
        >
          Save and Preview
        </ColorButton>
      </Condition>

      <Condition shouldRender={!isNew} className="flex">
        <ColorButton
          onClick={onDeleteClick}
          title={tooltip}
          disabled={!isEditable}
          className="mr-auto"
          colorClass={`${!isEditable ? 'gray' : 'dark-red'}`}
          borderClass={`${!isEditable ? 'b--gray' : 'b--op-brand'}`}
        >
          Delete
        </ColorButton>
        <Condition shouldRender={toolEnabled}>
          <a className="link" onClick={navigateToLibrary}>
            <ColorButton colorClass="gray" borderClass="b--gray">
              Cancel
            </ColorButton>
          </a>
        </Condition>
        <Condition shouldRender={!toolEnabled}>
          <Link className="link" to={OLD_LIBRARY_URL}>
            <ColorButton colorClass="gray" borderClass="b--gray">
              Cancel
            </ColorButton>
          </Link>
        </Condition>

        <span className="ml3">
          <CopyEmbedScript poll={poll} customer={poll.customerId}>
            <ColorButton borderClass="b--black">Copy Embed Script</ColorButton>
          </CopyEmbedScript>
        </span>

        <span className="ml3">
          <CopyPollUrl poll={poll}>
            <ColorButton borderClass="b--black">Copy URL</ColorButton>
          </CopyPollUrl>
        </span>

        <span className="ml3">
          <CopyPollButton poll={poll} />
        </span>

        <a
          href={pollPreviewUrl(poll)}
          rel="noopener noreferrer"
          target="_blank"
        >
          <ColorButton
            className="ml3"
            colorClass="op-con-dark"
            borderClass="b--op-con-dark"
          >
            Preview
          </ColorButton>
        </a>

        <ColorButton
          onClick={onSaveClick}
          title={tooltip}
          disabled={isSaveDisabled}
          className="ml3"
          colorClass={`${isSaveDisabled ? 'gray' : 'op-brand'}`}
          borderClass={`${isSaveDisabled ? 'b--gray' : 'b--op-brand'}`}
        >
          Save
        </ColorButton>
      </Condition>
    </div>
  )
}

const mapStateToProps = state => {
  const user = selectCurrentUser(state)
  return {
    hasDmpPermissions: user != null && hasDmpPermissions(user),
    toolEnabled: isToolUser(user),
  }
}

export default connect(
  mapStateToProps,
  {
    savePoll: pollBuilderSaveButtonClick,
    deletePoll: pollBuilderDeleteButtonClick,
  }
)(Controls)



// WEBPACK FOOTER //
// ./src/components/PollForm/Controls.js